import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Zap, Eye, Clock } from "lucide-react";
import { catBySlug } from "@/data/categories";
import { FavouriteButton } from "@/components/FavouriteButton";

export const FactCard = ({ fact, index = 0 }) => {
  const cat = catBySlug(fact.category);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      data-testid={`fact-card-${fact.id}`}
    >
      <Link
        to={`/fact/${fact.slug}`}
        className="group block h-full rounded-2xl border border-slate-200 bg-white overflow-hidden hover:-translate-y-1.5 hover:border-gold hover:shadow-[0_20px_40px_-20px_rgba(37,99,235,0.35)] transition-all duration-300"
      >
        <div className="relative aspect-[16/10] overflow-hidden">
          <img
            src={fact.image_url}
            alt={fact.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-all duration-500"
          />
          <span className={`absolute top-3 left-3 px-2.5 py-1 rounded-full text-[11px] font-mono uppercase tracking-wider border ${cat.chip}`}>
            {cat.name}
          </span>
          <span className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 rounded-full text-[11px] font-mono bg-white/90 backdrop-blur text-ink border border-gold">
            <Zap className="w-3 h-3" /> {fact.weirdness}
          </span>
        </div>
        <div className="p-6">
          <h3 className="font-display text-xl font-bold leading-snug text-ink group-hover:text-gold transition-colors line-clamp-3">
            {fact.title}
          </h3>
          <p className="mt-3 text-sm text-ink-muted leading-relaxed line-clamp-2">{fact.summary}</p>
          <div className="mt-5 flex items-center gap-4 text-xs font-mono text-ink-muted">
            <span className="flex items-center gap-1"><Eye className="w-3.5 h-3.5" /> {fact.views?.toLocaleString?.() ?? fact.views}</span>
            <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {fact.read_time} min</span>
            <FavouriteButton factId={fact.id} variant="inline" />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
